import { Base } from '../base-component';
import './event-card.component.scss';

export class EventCard extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/event-card/event-card.component.ts